/* eslint-disable no-const-assign */
/* jshint ignore:start */
import React, { useState } from "react";
import './App.css';
import SearchBar from "./components/SearchBar";
import API from "./API/Api";
import ImageList from "./components/ImageList";

const App = () => {
  const [state, setState] = useState([]);
  const [count, setCount] = useState(null);
  const submitHandler = async (value) => {
    const response = await API.get("search/photos", {
      params: { query: value },
    });

    setState(response.data.results);
    setCount(response.data.results.length);
  };

  return (
    <div className="container" style={{ marginTop: "10px" }}>
      <div className="header">FindAny#Frame</div>
      <SearchBar submitHandler={submitHandler} />
      <ImageList imageList={state} count={count} />
    </div>
  );
};

export default App;
